package dairy.mynotes.ui.theme

import androidx.compose.ui.graphics.Color

object AppColors {
    // Brand Colors – Deep Indigo + Teal accent
    val Primary = Color(0xFF4F46E5)           // Indigo
    val PrimaryVariant = Color(0xFF3730A3)    // Deep Indigo
    val PrimaryLight = Color(0xFFEEF2FF)      // Indigo tint background

    val Secondary = Color(0xFF0EA5E9)         // Sky Blue accent
    val SecondaryVariant = Color(0xFF0284C7)

    // Surfaces
    val Background = Color(0xFFF8FAFC)        // Soft off-white
    val Surface = Color(0xFFFFFFFF)
    val SurfaceVariant = Color(0xFFF1F5F9)    // Subtle card bg

    // Category / Section
    val CategoryBadgeBg = Color(0xFFE0E7FF)   // Indigo tint
    val CategoryBadgeText = Color(0xFF4338CA)
    val DividerColor = Color(0xFFE2E8F0)

    // Note Card accent bar colors (per category variety)
    val AccentGreen = Color(0xFF10B981)
    val AccentOrange = Color(0xFFF59E0B)
    val AccentPurple = Color(0xFF8B5CF6)
    val AccentRed = Color(0xFFEF4444)
    val AccentBlue = Color(0xFF3B82F6)

    // Text
    val TextPrimary = Color(0xFF0F172A)       // Near-black
    val TextSecondary = Color(0xFF64748B)     // Muted
    val TextHint = Color(0xFF94A3B8)

    // Status
    val Error = Color(0xFFDC2626)
    val Success = Color(0xFF16A34A)

    // Legacy aliases (keep for compatibility)
    val OnPrimary = Color(0xFFFFFFFF)
    val OnSecondary = Color(0xFF000000)
    val OnBackground = Color(0xFF0F172A)
    val OnSurface = Color(0xFF0F172A)
    val OnError = Color(0xFFFFFFFF)
    val LightGray = Color(0xFFCBD5E1)
    val IconTint = Color(0xFF475569)
}